// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Chart2, Flag, Layer, Profile2User, Setting4 } from 'iconsax-react';

// ==============================|| MENU ITEMS - STAFF INCENTIVES ||============================== //
// Two incentive schemes, each its own titled sidebar group (like Store
// Incentives). Every page is shown per user via the Advanced Features toggles.
//  - Clusterwise: cluster targets, payout pool split across the cluster's staff
//  - Slabwise: per-staff Big/Small targets with slab rates

export const clusterwiseIncentives = {
  id: 'group-clusterwise-incentives',
  title: <FormattedMessage id="Clusterwise Incentives" />,
  icon: Layer,
  type: 'group',
  children: [
    {
      id: 'staff-incentives-clusterwise-dashboard',
      title: <FormattedMessage id="Dashboard" />,
      type: 'item',
      icon: Chart2,
      url: '/staff-incentives/clusterwise/dashboard',
    },
    {
      id: 'staff-incentives-clusterwise-targets',
      title: <FormattedMessage id="Cluster Targets" />,
      type: 'item',
      icon: Flag,
      url: '/staff-incentives/clusterwise/targets',
    },
  ],
};

export const slabwiseIncentives = {
  id: 'group-slabwise-incentives',
  title: <FormattedMessage id="Slabwise Incentives" />,
  icon: Profile2User,
  type: 'group',
  children: [
    {
      id: 'staff-incentives-slabwise-dashboard',
      title: <FormattedMessage id="Dashboard" />,
      type: 'item',
      icon: Chart2,
      url: '/staff-incentives/slabwise/dashboard',
    },
    {
      id: 'staff-incentives-slabwise-targets',
      title: <FormattedMessage id="Staff Targets" />,
      type: 'item',
      icon: Setting4,
      url: '/staff-incentives/slabwise/targets',
    },
  ],
};
